<template>
  <v-app-bar app
             class="primary"
             dark
             style="z-index: 9999999">
    <v-toolbar-title class="mr-10">
      <a @click="onLogoClick">
        <v-img contain
               src="@/assets/logo-small.png"
               max-height="50" />
      </a>
    </v-toolbar-title>
    <v-toolbar-items v-for="item in menu"
                     :key="item.title"
                     class="hidden-sm-and-down">
      <v-btn v-if="!item.requires || item.requires.includes(permission)"
             :to="item.to"
             text
             active-class="accent white--text"
             dark>
        {{ item.title }} <v-icon small
                class="ml-2">{{item.icon}}</v-icon>
      </v-btn>
    </v-toolbar-items>
    <slot />
    <v-spacer />
    <v-toolbar-items v-if="account">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text
                 class="font-weight-normal"
                 v-on="on">
            <v-icon class="hidden-md-and-up">
              fas fa-bars
            </v-icon>
            <span class="hidden-sm-and-down">{{ account.name }}</span>
            <v-avatar size="40px"
                      class="ml-4 hidden-sm-and-down">
              <v-icon>
                fas fa-bars
              </v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <div v-for="item in menu"
               :key="item.title"
               class="hidden-md-and-up">
            <v-list-item v-if="!item.requires || item.requires.includes(permission)"
                         :to="item.to">
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </div>
          <v-list-item @click="onSignOut">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-toolbar-items v-else>
      <v-btn text
             :to="{name: 'Login'}">Login</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
export default {
  props: {
    onDrawerToggle: {
      type: Function,
      required: true,
    },
    onSignOut: {
      type: Function,
      required: true,
    },
    onLogoClick: {
      type: Function,
      required: true,
    },
    account: {
      type: Object,
      default: () => {},
    },
    menu: {
      type: [Object, Array],
      default: () => [],
    },
    permission: {
      type: String,
      default: () => 'pesquisador',
    },
  },
};
</script>
